import React, { useState } from "react";
import { Form, Input, Radio, Row, Button, message } from "antd/es";
import { CloseButton, Modal } from "react-bootstrap";
import { wareHouseInward, wareHouseTransit } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { useLocation } from "react-router-dom";

function OutwardTransitModal({ show, setShow, order }) {
  const [form] = Form.useForm();
  const [showFields, setShowFields] = useState({});
  const [allocationType, setAllocationType] = useState("");
  const { postInwardData } = wareHouseInward();
  const { setToaster } = useToast();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");
  const {fetchTransitData}=wareHouseTransit();

  const approveOutwards = async (data) => {
    const temp = form.getFieldValue("quantity");

    const allocatedQuantity = form.getFieldValue("quantity");

    if (allocationType === "allocateCustom") {
      const availableToAllocateQty = order.quantity - order.inwardedQuantity;

      if (allocatedQuantity > availableToAllocateQty) {
		setToaster("Allocation failed", `Allocation Failed, ${availableToAllocateQty} can be allocated, received ${allocatedQuantity}`, "danger");
		setTimeout(()=>{
			setShow(false);
		},[500])
        return;
      }
    }

    let res = {};
    let inwardOutwardArray;

    if (allocationType === "allocateAll") {
      inwardOutwardArray = [
        {
          inwardId: order.warehouseInwardId,
          batchCode: order.batchCode,
          skuId: order.skuId,
          supplierId: order.supplierId,
          batchImporterId: order.batchImporterId,
          quantity: order.quantity,
          companyName: order.companyName,
          supplierInvoiceNumber: order.supplierInvoiceNumber,
          notes: order.notes,
          shipmentNotes: order.shipmentNotes,
          challanNumber: order.challanNumber,
          challanNotes: order.challanNotes,
          fromWarehouseId: order.fromWarehouseId,
          toWarehouseId: order.toWarehouseId,
          inwardedQuantity: order.quantity - order.inwardedQuantity,
          uniqueCode: order.uniqueCode,
        },
      ];
    } else if (allocationType === "allocateCustom") {
      inwardOutwardArray = [
        {
          inwardId: order.warehouseInwardId,
          batchCode: order.batchCode,
          skuId: order.skuId,
          supplierId: order.supplierId,
          batchImporterId: order.batchImporterId,
          quantity: order.quantity,
          // quantity: form.getFieldValue("quantity"),
          companyName: order.companyName,
          supplierInvoiceNumber: order.supplierInvoiceNumber,
          notes: order.notes,
          shipmentNotes: order.shipmentNotes,
          challanNumber: order.challanNumber,
          challanNotes: order.challanNotes,
          fromWarehouseId: order.fromWarehouseId,
          toWarehouseId: order.toWarehouseId,
          // inwardedQuantity: allocatedQuantity,
          inwardedQuantity: parseInt(allocatedQuantity),
          uniqueCode: order.uniqueCode,
        },
      ];
    }

    postInwardData(
      {
        category: "inward_from_outward",
        inwardOutwardArray: inwardOutwardArray,
      },
      setToaster,
      tab,
	  fetchTransitData
    );

    setTimeout(() => {
      setShow(false);
    }, [500]);
  };

  const handleShowFields = (name, value) => {
    setShowFields((curr) => {
      const _curr = curr;
      _curr[name] = value;
      return { ..._curr };
    });
  };

  const handleAllocationChange = ({ target }) => {
    setAllocationType(target.value);
    setShowFields({});
    form.resetFields();

    if (target.value === "allocateAll") {
      handleShowFields("allocateAll", true);
      handleShowFields("allocateCustom", false);
    } else if (target.value === "allocateCustom") {
      handleShowFields("allocateCustom", true);
      handleShowFields("allocateAll", false);
    }
  };

  return (
    <div>
      <Modal show={show} fullscreen="sm-down" onHide={() => setShow(false)}>
        <Modal.Header>
          <Modal.Title>Modal</Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <div className="grid gap-1 justify-items-center">
            <Row justify="center">
              <Radio.Group
                optionType="button"
                buttonStyle="outline"
                size="large"
                onChange={handleAllocationChange}
                value={allocationType}
              >
                <Radio.Button value="allocateAll">
                  Allocate All Quantity
                </Radio.Button>
                <Radio.Button value="allocateCustom">
                  Allocate Custom Quantity
                </Radio.Button>
              </Radio.Group>
            </Row>
            <Form form={form} onFinish={approveOutwards} name="form">
              <div
                style={{
                  marginTop: "5%",
                }}
              >
                {showFields.allocateCustom && (
                  <>
                    <Row justify="center">
                      <Form.Item
                        label="Quantity"
                        name="quantity"
                        rules={[
                          { required: true, message: "Please fill this" },
                          {
                            pattern: new RegExp(/^[0-9]+$/),
                            message: "Please enter numbers only",
                          },
                        ]}
                      >
                        <Input rows={4} style={{ width: 150 }} />
                      </Form.Item>

                      <Form.Item>
                        <Button type="primary" htmlType="submit">
                          Approve
                        </Button>
                      </Form.Item>
                    </Row>
                  </>
                )}

                {showFields.allocateAll && (
                  <Row justify="center">
                    <Form.Item>
                      <Button type="primary" htmlType="submit">
                        Approve
                      </Button>
                    </Form.Item>
                  </Row>
                )}
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default OutwardTransitModal;
